import script from "./SignUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignUp.vue?vue&type=script&lang=ts&setup=true"

import "./SignUp.vue?vue&type=style&index=0&id=621affba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-621affba"]])

export default __exports__